var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.clientLanguageList.length > 0)?_c('div',[_c('v-select',_vm._b({attrs:{"items":_vm.clientLanguageList,"value":_vm.modelValue},on:{"input":(newValue) => (_vm.modelValue = newValue)}},'v-select',_vm.$props,false))],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }